import React from 'react'
import StarRating from './StarRating'

interface RatingSummaryProps {
  averageRating: number | null
  commentsCount: number
  className?: string
}

const RatingSummary = ({
  averageRating,
  commentsCount,
  className
}: RatingSummaryProps) => {
  if (commentsCount === 0 || averageRating === null) return null

  return (
    <span className={className}>
      <StarRating value={averageRating} size={11} /> ({commentsCount})
    </span>
  )
}

export const renderRatingMeta = (row: {
  averageRating: number | null
  commentsCount: number
}) => (
  <RatingSummary
    averageRating={row.averageRating}
    commentsCount={row.commentsCount}
    className="ms-2"
  />
)

export default RatingSummary
